import { render, staticRenderFns } from "./bill_detail.vue?vue&type=template&id=b1db9564&scoped=true&"
import script from "./bill_detail.vue?vue&type=script&lang=js&"
export * from "./bill_detail.vue?vue&type=script&lang=js&"
import style0 from "./bill_detail.vue?vue&type=style&index=0&id=b1db9564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1db9564",
  null
  
)

export default component.exports